import Service, { inject as service } from '@ember/service';
import getPreviewVariables, { PreviewVariablesArgs } from 'cio/utils/get-preview-variables';
import ApiService from 'cio/services/api';
import TemplateModel from 'cio/models/template';
import LayoutModel from 'cio/models/layout';

const DEFAULT_LAYOUT = '{{content}}';
type GenerateDataArgs = Omit<PreviewVariablesArgs, 'selectedLayout'> & {
  layout?: LayoutModel;
};

export default class EmailPreviewService extends Service {
  @service api!: ApiService;

  generate(template: TemplateModel, attrs: GenerateDataArgs) {
    let data = this.generateData(template, attrs);
    return this.api.post('previews/email', { data });
  }

  generateData(
    template: TemplateModel,
    {
      customer,
      selectedEvent,
      selectedTrigger,
      templateVariables,
      layout = template.get('layout'),
      objects,
    }: GenerateDataArgs,
  ) {
    let variables = getPreviewVariables({
      customer,
      selectedEvent,
      selectedTrigger,
      templateVariables,
      objects,
    });

    let templateData = this.generateTemplateData(template, layout);
    templateData.variables = variables;
    return templateData;
  }

  generateTemplateData(template: TemplateModel, layout: LayoutModel = template.get('layout'), isLayoutIgnored = false) {
    let layoutBody = DEFAULT_LAYOUT;

    if (!isLayoutIgnored) {
      layoutBody = layout?.get('body') || DEFAULT_LAYOUT;
    }

    return {
      bcc: template.get('bcc'),
      body: template.get('body'),
      body_amp: template.get('bodyAmp'),
      from: template.fromIdentity?.get('address'),
      reply_to: template.replyToIdentity?.get('email'),
      subject: template.get('subject'),
      preheader_text: template.get('preheaderText'),
      to: template.get('recipient'),
      preprocessor: template.get('preprocessor'),
      track_links:
        (template.action?.tracked || template.newsletter?.tracked || template.transactionalMessage?.linkTracking) ??
        false,

      headers: template.headers,
      layout: layoutBody,
      variables: {},
    };
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'email-preview': EmailPreviewService;
  }
}
